import { render } from "./CardRenderCorpBoxComponent.vue?vue&type=template&id=7887553c&ts=true"
import script from "./CardRenderCorpBoxComponent.vue?vue&type=script&lang=ts"
export * from "./CardRenderCorpBoxComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__